import HomeNavbarMixin from "@/shared/mixin/HomeNavbarMixin";

export default {
  mixins: [HomeNavbarMixin],
  data() {
    return {
      titulo: "A400"
    };
  }
};
